const createReactClass = require('create-react-class');

const OptionButtons = createReactClass({
  getInitialState() {
    return {
      selected: this.props.initialValue
    };
  },
  getSelectedOptionValue() {
    return this.state.selected;
  },
  handleOptionClick(optionVal) {
    if (this.state.selected == optionVal) return this.setState({ selected: null });
    this.setState({ selected: optionVal });
  },
  createOptionButton(optionHash) {
    let classes = 'btn-slim brown option-select';
    let text = optionHash.name.toLowerCase();
    if (this.state.selected == optionHash.value) {
      classes += ' selected';
      text += ' ×';
    }
    return (
      <a key={optionHash.value} className={classes} onClick={this.handleOptionClick.bind(null, optionHash.value)} data-testid={text}>
        {text}
      </a>
    );
  },
  render() {
    const optionButtons = this.props.optionDefs.map(this.createOptionButton);
    let classes = 'option-button-group';
    if (this.props.extraClasses) classes = `${classes} ${this.props.extraClasses}`;
    return <div className={classes}>{optionButtons}</div>;
  }
});

export { OptionButtons };
